import { render, staticRenderFns } from "./TabbedProductInventory.vue?vue&type=template&id=cedce726&scoped=true"
import script from "./TabbedProductInventory.vue?vue&type=script&lang=js"
export * from "./TabbedProductInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedce726",
  null
  
)

export default component.exports